import React, { FC } from 'react';

import ModalScreen from 'components/Modals/ModalScreen';

import ExtraInfoLoader from 'components/Loaders/ExternalInfo';
import useConnect from './connect';
import {
  Container,
  Actions,
  ButtonsBlock,
  ActionButton,
  LoadersWrapper,
} from './styles';
import ExtraInfo from './ExtraInfo';
import Summary from './Summary';
import SummaryLoader from './Summary/Loader';

const OrderDetail: FC = () => {
  const { handleClose, order, isLoading, handlePrintOrder } = useConnect();

  if (!order && !isLoading) {
    return <>{handleClose()}</>;
  }

  if (!order && isLoading) {
    return (
      <ModalScreen open title="Order History Detail" handleClose={handleClose}>
        <Container>
          <LoadersWrapper>
            <SummaryLoader opacity={1} />
            <SummaryLoader opacity={0.5} />
          </LoadersWrapper>
          <ExtraInfoLoader />
        </Container>
      </ModalScreen>
    );
  }

  return (
    <ModalScreen open title="Order History Detail" handleClose={handleClose}>
      <Container>
        {order && (
          <>
            <Summary order={order} />
            <ExtraInfo order={order} />
          </>
        )}
      </Container>
      <Actions>
        <ButtonsBlock>
          {order && <ActionButton variant="print" onClick={handlePrintOrder} />}
        </ButtonsBlock>
      </Actions>
    </ModalScreen>
  );
};

export default OrderDetail;
